import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../UI/button';
import { useAddFolder } from '../modals/folder/use-add-folder';

const folderTypes = [
  'accommodation',
  'transport',
  'activities',
  'food & dining',
  'places to visit',
  'custom'
];

type AddFormProps = {
  tripId: string;
  parentFolderId?: string;
  submitTitle: string;
  label: string;
  placeholder?: string;
  onSuccess?: () => void;
};

const AddForm = ({
  label,
  placeholder,
  parentFolderId = '',
  tripId,
  submitTitle,
  onSuccess
}: AddFormProps) => {
  const { folder, validated, handleInputChange, handleSubmit } = useAddFolder(
    tripId,
    parentFolderId,
    onSuccess
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group>
        <Form.Label>Select folders to include in this destination:</Form.Label>
        <div
          style={{
            border: '1px solid #dee2e6',
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 8,
            background: '#fafbfc'
          }}
        >
          {folderTypes.map((type) => (
            <Form.Check
              key={type}
              type='radio'
              name='folderType'
              label={type}
              checked={folder.folderType === type}
              onChange={(e) => {
                if (e.target.checked) {
                  handleInputChange('folderType', type);
                }
              }}
              style={{ marginBottom: 4 }}
            />
          ))}
        </div>
      </Form.Group>
      {folder.folderType === 'custom' && (
        <>
          <Form.Group>
            <Form.Label>{label}</Form.Label>
            <Form.Control
              type='text'
              placeholder={placeholder}
              value={folder.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as='textarea'
              rows={3}
              placeholder='Enter description'
              value={folder.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
            />
          </Form.Group>
        </>
      )}
      <Button
        disabled={!validated}
        type='submit'
        width={167}
        className='mx-auto'
        style={{ marginTop: '24px' }}
      >
        {submitTitle}
      </Button>
    </Form>
  );
};

export default AddForm;
